module.exports = __webpack_public_path__ + "img/icone-gray.af59415c.webp";